'use strict';

var log = require('../../log/Log').channel('ShowPasswordExtension');

var ShowPasswordExtension = function($timeout) {
    log.info('initializing');

    var vm = this;

    // Since these functions are bound expressions, they are mixed
    // directly into the object utilizing them, rather than a child
    // object.
    vm.showPassword = false;
    vm.focusedField = '';
    vm.getPasswordFieldId = getPasswordFieldId;
    vm.focusTextField = focusTextField;
    vm.blurTextField = blurTextField;

    function getPasswordFieldId() {
        var passwordFieldId = '';
        if (vm.focusedField === 'password') {
            passwordFieldId = 'password';
            $timeout(function() {
                cordova.plugins.Keyboard.show();               
            }, 500);
        }

        log.debug('passwordFieldId = ' + passwordFieldId);
        return passwordFieldId;
    }

    function focusTextField($event) {
        vm.focusedField = $event.target.id;

        if ($event.target.type === 'password') {
            // timeout required on Chromium to select input contents
            $timeout(function() {
                $event.target.select();
            }, 50);
        }
    }

    function blurTextField() {
        vm.focusedField = '';
    }
};

module.exports = ShowPasswordExtension;
